module.exports = __webpack_public_path__ + "static/img/12e616fb6f1740feb51db49fc39aa3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contactus.jpg
// module id = KG88
// module chunks = 1